import { Table } from 'reactstrap';
import { useKeycloak } from "@react-keycloak/web";
import PrevDoplnek from './PrevDoplnek';

function ListingDoplnku(props: any) {
    const { keycloak, initialized } = useKeycloak();
    /*
    console.log("<ListingDoplnku debug of vars")
    console.log("props")
    console.log(props)
    console.log("-END-")
    */
    return (<Table striped hover size="sm">
            <thead>
                <tr>
                    <th>KÓD</th>
                    <th>NÁZEV</th>
                    <th>VZOREK</th>
                    <th>POUŽITÍ</th>
                    <th>KLASIFIKACE</th>
                    <th>POPIS</th>
                    <th>MODIFIKACE</th>
                    <th>POZNÁMKA</th>
                    <th>DOSTUPNOST</th>
                    <th>UPRAVENO</th>
                    {keycloak.authenticated && (<th>VIDITELNOST</th>)}
                </tr>
            </thead>
            <tbody>
                {(props.doplnky.length!==0) ?
                props.doplnky.map((doplnek: any) => <PrevDoplnek key={doplnek.id} doplnek={doplnek} />):
                <tr><td>ZADNE VYSLEDKY NA ZAKLADE FILTROVANI</td></tr>}
            </tbody>
        </Table>)
}
export default ListingDoplnku